export const sanitizeTitle = (title) => {
    if(title === null) return null;
    // Remove HTML tags
    let sanitizedTitle = title.replace(/<\/?[^>]+(>|$)/g, "");
    // Remove special characters or any other desired sanitization
    sanitizedTitle = sanitizedTitle.replace(/[^a-zA-Z0-9\s]/g, "");
    return sanitizedTitle;
};